import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EvaluationSouvenorsModel } from './EvaluationSouvenorsModel';
@Injectable({
  providedIn: 'root'
})
export class EvaluationSouvenirsService {

  
  
  constructor(private http: HttpClient ) { }
  baseUrl = environment.baseApiUrl;
  token = localStorage.getItem("token");
  httpOptions = {
   headers: new HttpHeaders({
      "Authorization": "Bearer " + this.token,
      "Content-Type": "application/json"
   })
 };

 

 GetAllBySouvenirId(foodId:number): Observable<any> {
   
  return this.http
    .get<any>(`${this.baseUrl}EvaluationSouvenirs/GetAllBySouvenirId/${foodId}`,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}

insert(payload: EvaluationSouvenorsModel): Observable<any> {
  
  return this.http
    .post<any>(`${this.baseUrl}EvaluationSouvenirs/Insert`, payload,this.httpOptions)
    .pipe(catchError((error: any) => throwError(error => error)));
}
}
